import { makeAutoObservable } from "mobx";
import * as PubSub from '../pubSub';
import * as DiscountProvider from '../../services/discount';
import { Manager } from "../../core";

export class DiscountStoreMobx {
  public list: any[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setList = (list: any[]) => {
    this.list = list;
  };

  get = async () => {
    try {
      const response: any = await DiscountProvider.get();
      // O data vem com a estrutura restresponse:  data.data
      const result = response?.data || response || [];
      this.setList(result);
      return result;
    } catch (e) {
      throw new Manager.ServiceError('error.discountStore.get', e);
    }
  };

  create = async (code: string, discount: number, expires: boolean = true) => {
    try {
      await DiscountProvider.create(code, discount, expires);
      await this.get();
    } catch (e) {
      throw new Manager.ServiceError('error.discountStore.create', e);
    }
  };

  delete = async (id: number) => {
    try {
      await DiscountProvider.deleteDiscount(id);
      await this.get();
    } catch (e) {
      throw new Manager.ServiceError('error.discountStore.delete', e);
    }
  };
}

let singleton: DiscountStoreMobx | null = null;

export const DiscountStore = () => {
  if (!singleton) {
    singleton = new DiscountStoreMobx();

    PubSub.subscribe(PubSub.LOGOUT, () => {
      singleton = null;
    });
  }
  return singleton;
};
